import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import DataTable from "examples/Tables/DataTable";
import Checkbox from "@mui/material/Checkbox";
import MDBadge from "components/MDBadge";

function AdminsTableData({ data, selectedIds, onToggle, onEdit, onDelete }) {
  const columns = [
    { Header: "", accessor: "checkbox", align: "center", width: "2%" },
    { Header: "name", accessor: "name", align: "left" },
    { Header: "email", accessor: "email", align: "left" },
    { Header: "phone", accessor: "phone", align: "left" },
    { Header: "status", accessor: "status", align: "center" },
    { Header: "reset", accessor: "reset", align: "center" },
    { Header: "action", accessor: "action", align: "center" },
  ];

  const rows = (data || []).map((a) => ({
    checkbox: (
      <Checkbox size="small" checked={selectedIds.includes(a.id)} onChange={() => onToggle(a.id)} />
    ),
    name: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.name}
      </MDTypography>
    ),
    email: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.email}
      </MDTypography>
    ),
    phone: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.phone}
      </MDTypography>
    ),
    status: (
      <MDBadge
        badgeContent={a.status}
        size="sm"
        container
        // optional: color mapping
        color={String(a.status).toLowerCase() === "active" ? "success" : "secondary"}
      />
    ),
    reset: (
      <MDBadge
        badgeContent={a.passwordResetStatus}
        size="sm"
        container
        color={a.passwordResetStatus === "require" ? "warning" : "success"}
      />
    ),
    action: (
      <div>
        <IconButton size="small" onClick={() => onEdit(a)}>
          <Icon fontSize="small">edit</Icon>
        </IconButton>
        <IconButton size="small" color="error" onClick={() => onDelete(a)}>
          <Icon fontSize="small">delete</Icon>
        </IconButton>
      </div>
    ),
  }));

  return (
    <DataTable
      table={{ columns, rows }}
      isSorted
      entriesPerPage={false}
      showTotalEntries={false}
      noEndBorder
      canSearch={false}
      size="small"
    />
  );
}

AdminsTableData.propTypes = {
  data: PropTypes.array.isRequired,
  selectedIds: PropTypes.array.isRequired,
  onToggle: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default AdminsTableData;
